import { api } from "../../shared/api/axios";

export async function fetchMotoristas() {
  const { data } = await api.get("/motoristas");
  return Array.isArray(data) ? data : data.data ?? [];
}

export async function createMotorista(payload) {
  const { data } = await api.post("/motoristas", payload);
  return data;
}

export async function updateMotorista({ id, ...payload }) {
  const { data } = await api.put(`/motoristas/${id}`, payload);
  return data;
}

export async function deleteMotorista(id) {
  await api.delete(`/motoristas/${id}`);
  return id;
}
